// extracted by mini-css-extract-plugin
module.exports = {"TooltipWrapper":"RecordingsCarouselSection-tooltip__TooltipWrapper--2fIkS","Tooltip":"RecordingsCarouselSection-tooltip__Tooltip--3fBFb"};